import axios from 'axios'
import Store from '@/store/index'
let authImg = {}
function authImage (el, { value, oldValue }) {
  if (!value || value == oldValue) return
  let axiosUrl = Store.state.operateObject.baseUrl + '/api/imgbed/v1/'
  if (axiosUrl === value) {
    el.src = require('@/assets/img/video.png')
    return
  }
  axios.get(value, { responseType: 'blob' }).then(res => {
    const url = URL.createObjectURL(res.data)
    el.src = url
    el.onload = () => {
      URL.revokeObjectURL(url)
    }
  }).catch(() => { el.src = require('@/assets/img/video.png') })
}
authImg.install = function (Vue) {
  Vue.directive('authImg', {
    bind: (el, binding) => authImage(el, binding),
    componentUpdated: (el, binding) => authImage(el, binding)
  })
}
export default authImg
